export default __webpack_public_path__ + "88b71935d50011bfc946562018974e69.png";